export const generateButton = (
  status,
  appId,
  assignappId,
  handleButtonClick,
  disabledButtons,
  name,
  instructions,
  labelOverride = null,
  tooltip = null,
) => {
  let buttonText = labelOverride;

  if (!buttonText) {
    if (status === "pending") {
      buttonText = "Iniciar →";
    } else if (status === "incomplete") {
      buttonText = "Continuar →";
    } else {
      return null;
    }
  }

  return [
    {
      buttonText,
      tooltip,
      onClick: () => handleButtonClick(appId, assignappId),
      disabled: disabledButtons,
    },
  ];
};

export const columns = [
  {
    id: "name",
    label: "Nombre de Aplicación",
    minWidth: 170,
  },
  {
    id: "status",
    label: "Estado",
    minWidth: 120,
  },
  {
    id: "maxDate",
    label: "Fecha de Cierre de la Aplicación",
    minWidth: 120,
  },
  {
    id: "actions",
    label: "Acciones",
    minWidth: 120,
    align: "left",
  },
];

export function createData(name, status, maxDate, actions) {
  return {
    name,
    status,
    maxDate,
    actions,
  };
}

export const statusLabel = (rawStatus) => {
  switch (rawStatus) {
    case "pending":
      return "Pendiente";
    case "incomplete":
      return "En progreso";
    case "complete":
    case "time_expired":
      return "Completado";
    default:
      return "Desconocido";
  }
};
